import { render } from "./TransactionAuditLog.vue?vue&type=template&id=6e6f03e8"
import script from "./TransactionAuditLog.vue?vue&type=script&lang=js"
export * from "./TransactionAuditLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__